import React from 'react';
import Icon from '../../../components/AppIcon';

const TOOLBAR_ACTIONS = [
  { icon: 'Bold', label: 'Bold' },
  { icon: 'Italic', label: 'Italic' },
  { icon: 'Underline', label: 'Underline' },
  { icon: 'List', label: 'Bullet List' },
  { icon: 'ListOrdered', label: 'Numbered List' },
  { icon: 'Link', label: 'Insert Link' },
];

const DocumentEditor = ({ content, onChange, placeholder }) => {
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      {/* Toolbar */}
      <div className="flex items-center gap-1 px-3 py-2 bg-gray-50 border-b border-gray-200 flex-wrap">
        {TOOLBAR_ACTIONS?.map((action) => (
          <button
            key={action?.label}
            type="button"
            title={action?.label}
            className="p-1.5 rounded hover:bg-gray-200 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <Icon name={action?.icon} size={15} />
          </button>
        ))}
        <div className="w-px h-5 bg-gray-300 mx-1" />
        <select className="text-xs border border-gray-200 rounded px-2 py-1 text-gray-600 bg-white focus:outline-none">
          <option>Paragraph</option>
          <option>Heading 1</option>
          <option>Heading 2</option>
          <option>Heading 3</option>
        </select>
      </div>
      {/* Editor Area */}
      <textarea
        value={content}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={placeholder}
        rows={20}
        className="w-full px-5 py-4 text-sm text-gray-800 leading-relaxed resize-none focus:outline-none font-mono"
      />
    </div>
  );
};

export default DocumentEditor;
